// Product copy in every language, for the fronts and the server alike (no
// dependency: importable from a React component, an API route, the worker or
// an email template). Conventions: docs/I18N.md.

import { en } from "./en";
import { fr, type Messages } from "./fr";
import type { Locale } from "./locales";

export type { Messages } from "./fr";
export * from "./locales";

export const MESSAGES: Record<Locale, Messages> = { fr, en };

/** The copy of a language. */
export function messages(locale: Locale): Messages {
  return MESSAGES[locale];
}
